/* eslint-disable react/require-default-props */

import { GetColorInputProps } from './color-picker-popover';
import ColorInput, { ColorInputProps } from './color-input';

// extract some props from the ColorInput component that will be passed down
type PassedProps = Pick<ColorInputProps, 'label' | 'onSubmit' | 'infoText'>;

// we extract some properties
interface DefaultColorPopoverInputProps<T extends GetColorInputProps<string>> extends PassedProps {
  // getColorInputProps is the function that is passed to this component from
  // the <ColorPickerPopover /> component. The first parameter is any valid
  // color value name (which is a subset of string).
  getColorInputProps: T;

  // this type extracts the valid color names from the getColorInputProps function
  name: Parameters<T>[0];
}

/**
 * utility components to be used along with the <ColorPickerPopover /> component
 * to display color inputs with less boilerplate.
 */
/* @ngInject */
export default function DefaultColorPopoverInput<T extends GetColorInputProps<string>>(props: DefaultColorPopoverInputProps<T>) {
  const inputProps = props.getColorInputProps(props.name);

  return (
    <ColorInput
      name={`color-popover-${props.name}`}
      label={props.label}
      infoText={props.infoText}
      onChange={(e) => {
        inputProps.onChange(e.target.value);
      }}
      value={inputProps.value}
      onValueChange={inputProps.onValueChange}
      showPalette={inputProps.showPalette}
      onSubmit={props.onSubmit}
    />
  );
}
